import { Modal } from '@Calix-Commerce/design-system/components';

type ModalProps = {
  isOpen: boolean;
  onConfirmation: () => void;
  onCancel: () => void;
};

const FileMissingModal = ({ isOpen, onConfirmation, onCancel }: ModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      position={'center'}
      title="PO Attachment Missing"
      content="Your attachment is no longer available. Click cancel to reattach or ok to proceed without it."
      flag="Warning"
      onConfirmation={onConfirmation}
      onCancel={onCancel}
    ></Modal>
  );
};

export { FileMissingModal };
